import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {withDefaults} from 'vue'


// Define component properties
interface Properties {
    icon?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClickIcon',
  props: {
    icon: { default: 'pi-trash' }
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as { icon: string };



// Define emits


// Define functions
function processClick() {
	emits('click')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["i-button pi text-red-500 cursor-pointer", props.icon || 'pi-trash']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (processClick()))
  }, null, 2))
}
}

})